export default __webpack_public_path__ + "/dist/images/market-pace-banner3.png.png";